import { setupMarkdownToolPage } from './shared/index.js';
import { applyImageMode, convertOfficeFile, OFFICE_MAX_INPUT_BYTES, requireUploadConsent } from './formats/docx/office-client.js';

function isDocx(file) {
  return Boolean(file && (/\.docx$/i.test(file.name) || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'));
}

export function initDocxPage(root = document) {
  const imageMode = root.querySelector('#docx-image-mode');
  const includeFootnotes = root.querySelector('#docx-include-footnotes');
  const uploadConsent = root.querySelector('#upload-consent');
  let sourceFile = null;
  let reading = false;
  const page = setupMarkdownToolPage({
    root,
    defaultFileName: 'docx-document',
    onFiles: async (files) => {
      const file = files?.[0];
      if (!file) return;
      try { requireUploadConsent(uploadConsent); } catch (error) { sourceFile = null; page.setReady(false); page.setStatus(error.message, 'error'); return; }
      if (files.length > 1) { page.setStatus('Choose one DOCX file at a time.', 'error'); return; }
      if (!isDocx(file)) { page.setStatus('Choose a DOCX file.', 'error'); return; }
      if (!file.size || file.size > OFFICE_MAX_INPUT_BYTES) {
        page.setStatus(`The DOCX file must be between 1 B and 50.0 MB.`, 'error');
        return;
      }
      if (reading) return;
      reading = true;
      sourceFile = file;
      page.setReady(true);
      page.setStatus(`${file.name} is ready. Choose image and note handling, then convert.`, 'success');
      reading = false;
    },
  });
  uploadConsent?.addEventListener('change', () => {
    if (!uploadConsent.checked) page.setReady(false);
    else if (sourceFile && !reading) page.setReady(true);
  });
  page.elements.convertButton?.addEventListener('click', () => {
    if (!sourceFile) return;
    try { requireUploadConsent(uploadConsent); } catch (error) { page.setStatus(error.message, 'error'); return; }
    const selectedImageMode = imageMode?.value || 'links';
    page.runConversion(async ({ signal, report }) => {
      const output = await convertOfficeFile(sourceFile, 'docx', {
        includeNotes: includeFootnotes ? Boolean(includeFootnotes.checked) : true,
      }, { signal, report, consent: Boolean(uploadConsent?.checked) });
      const converted = applyImageMode(output, selectedImageMode);
      report('Markdown is ready.', 1);
      return converted;
    }).catch(() => {});
  });
  page.elements.clearButton?.addEventListener('click', () => {
    sourceFile = null;
    page.setReady(false);
    page.result.clear();
    page.setStatus('Source cleared.');
  });
  page.setReady(false);
  return { page, get sourceFile() { return sourceFile; } };
}

if (typeof document !== 'undefined' && document.documentElement.dataset.markdownFormat === 'docx') initDocxPage();
